import React, { useState, useEffect, useRef, Fragment, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import H3Text from '@Uilib/h3Text';
import RequestOtp from '@Components/Login/RequestOtp';
import VerifyOtp from '@Components/Login/VerifyOtp';
import UserActions from '@Actions/userActions';
import './style.scss';

const LoginFormWrapper = ({
  otpRequestResponse,
  requestOtpError,
  requestOtpSuccess,
  onClickSignup,
  otpError,
  signupUserInfoFast,
}) => {
  const [userInput, setUserInput] = useState('');
  const [otpRequested, setOtpRequested] = useState(false);
  const [otpInput, setOtpInput] = useState('');
  const [time, setTime] = useState(60);
  const [complete, setComplete] = useState(false);

  const timerRef = useRef(null);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      requestOtpSuccess(null, null, null);
      clearInterval(timerRef.current);
    };
  }, [requestOtpSuccess]);

  // Countdown logic
  useEffect(() => {
    if (time === 0) {
      clearInterval(timerRef.current);
      setComplete(true);
    }
  }, [time]);

  const initiate = useCallback(() => {
    setTime((prev) => prev > 0 ? prev - 1 : 0);
  }, []);

  const start = useCallback(() => {
    clearInterval(timerRef.current);
    timerRef.current = setInterval(initiate, 1000);
  }, [initiate]);

  const startTimer = useCallback(() => {
    setTime(60);
    setComplete(false);
    start();
  }, [start]);

  const onUserInputChange = useCallback(
    (val) => {
      setUserInput(val);
      if (otpError) requestOtpError(null);
    },
    [otpError, requestOtpError]
  );

  const showRequestOtp = !otpRequestResponse || !otpRequestResponse.user?.first_name;

  return (
    <Fragment>
      <H3Text
        text={signupUserInfoFast ? 'Sign up to Procuzy' : 'Welcome Back!'}
        className="login__welcome-text"
      />

      {showRequestOtp && !signupUserInfoFast ? (
        <RequestOtp
          userInput={userInput}
          otpRequested={otpRequested}
          onChangeUserInput={onUserInputChange}
          updateOtpRequested={setOtpRequested}
          startTimer={startTimer}
          onClickSignup={onClickSignup}
        />
      ) : (
        <VerifyOtp
          otpInput={otpInput}
          userInput={userInput}
          secondsRemaining={time}
          startTimer={startTimer}
        />
      )}
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers }) => ({
  requestOtpLoading: UserReducers.requestOtpLoading,
  otpRequestResponse: UserReducers.otpRequestResponse,
  signupUserInfoFast: UserReducers.signupUserInfoFast,
  otpError: UserReducers.otpError,
});

const mapDispatchToProps = (dispatch) => ({
  requestOtpError: (error) => dispatch(UserActions.requestOtpError(error)),
  requestOtpSuccess: (otpResponse, requestType, requestValue) =>
    dispatch(UserActions.requestOtpSuccess(otpResponse, requestType, requestValue)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LoginFormWrapper));
